// extracted by mini-css-extract-plugin
export default {"root":"root--W5yvh","inner":"inner--jsFIr"};